<template>
  <b-form @submit.prevent>
    <b-form-group
      label="پکیج هدیه را انتخاب کنید"
      label-for="support-package-picker"
    >
      <v-select
        @search="handleSearch"
        id="support-package-picker"
        dir="rtl"
        :filterable="false"
        v-if="supportList"
        :reduce="(supportPackage) => supportPackage.counselingPackageId"
        v-model="selectedSupportPackage"
        :options="supportList"
        label="title"
      >
        <template #no-options>هیچ پکیجی جهت نمایش وجود ندارد</template>
      </v-select>
    </b-form-group>
  </b-form>
</template>
<script>
export default {
  emits: ["getSupportPackage"],
  props: {
    defaultCounselingPackageId: {
      type: [Number, String, null],
      required: false,
      default: null,
    },
  },
  watch: {
    selectedSupportPackage: {
      handler(val) {
        this.$emit("getSupportPackage", val);
      },
    },
    defaultCounselingPackageId: {
      immediate: true,
      handler(val) {
        // اگر مقدار ایدی اولیه تغییر کرد یا در بار اول ست شد
        // و supportList لود نشده بود، لیست را بگیر
        if (val && val != "" && val != 0) {
          this.getAllSupportList();
        }
        // اگر لیست آماده است و مقدار اولیه خاصی اومد، ست کن
        this.setSelectedFromDefault();
      },
    },
    supportList: {
      handler() {
        // هربار که لیست تغییر کرد تلاش کن مقدار انتخاب شده را از prop ست کنی
        this.setSelectedFromDefault();
      },
    },
  },
  mounted() {
    this.getAllSupportList();
  },
  data() {
    return {
      isLoading: false,
      supportList: null,
      selectedSupportPackage: null,
      searchVal: null,
      timeout: null,
      supportListFilters: {
        pageNumber: 1,
        count: 10,
        startDateTime: null,
        endDateTime: null,
        studentFullName: null,
        masterFullName: null,
      },
      totalCount: 0,
    };
  },
  methods: {
    handleSearch(searchValue, loadingFn) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.searchVal = searchValue;
        loadingFn(true);
        await this.getAllSupportList();
        loadingFn(false);
      }, 300);
    },
    async getAllSupportList() {
      try {
        this.isLoading = true;

        const _this = this;

        const getAllConsultList = new ListCounselingPackageForAdmin(_this);
        getAllConsultList.setRequestParamDataObj(_this.supportListFilters);

        await getAllConsultList.fetch((res) => {
          if (res.isSuccess) {
            _this.supportList = res.data.data;
            _this.totalCount = res.data.total;
            // پس از دریافت لیست تلاش کن مقدار انتخاب شده را مطابق prop ست کنی
            _this.setSelectedFromDefault();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setSelectedFromDefault() {
      // اگر prop مقدار دارد و لیست آمده و selectedSupportPackage هنوز ست نیست یا فرق دارد
      if (
        this.defaultCounselingPackageId &&
        this.supportList &&
        Array.isArray(this.supportList)
      ) {
        // اگر انتخابی الان با prop فرق دارد یا هنوز ست نشده
        if (this.selectedSupportPackage !== this.defaultCounselingPackageId) {
          // اگر آیتمی با این ایدی در لیست هست، ست کن، وگرنه فقط ایدی را ست کن (تا ویزیو سلکت کار کند)
          const found = this.supportList.find(
            (item) =>
              item &&
              (item.counselingPackageId == this.defaultCounselingPackageId ||
                item.id == this.defaultCounselingPackageId)
          );
          // طبق reduce در v-select باید مقدار ایدی باشه!
          if (found) {
            this.selectedSupportPackage = found.counselingPackageId;
          } else {
            this.selectedSupportPackage = this.defaultCounselingPackageId;
          }
        }
      }
      // اگر prop مقدار ندارد ولی چیزی ست شده بود پاک کن
      if (
        (!this.defaultCounselingPackageId ||
          this.defaultCounselingPackageId === 0 ||
          this.defaultCounselingPackageId === "" ||
          this.defaultCounselingPackageId === null) &&
        this.selectedSupportPackage
      ) {
        this.selectedSupportPackage = null;
      }
    },
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
  },
};
import { BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import { ListCounselingPackageForAdmin } from "@/libs/Api/Counseling";
</script>
